export const normalizeComparableUrl = (value = "") => {
  const input = String(value || "").trim();
  if (!input) return "";

  try {
    const normalizedInput = /^https?:\/\//i.test(input)
      ? input
      : `https://${input}`;
    const parsedUrl = new URL(normalizedInput);
    parsedUrl.hash = "";
    return parsedUrl.toString().replace(/\/$/, "");
  } catch (error) {
    return input.replace(/\/$/, "");
  }
};

export const dedupeUrls = (urls = []) => {
  const seen = new Set();
  const result = [];

  urls.forEach((url) => {
    const normalizedUrl = normalizeComparableUrl(url);
    if (!normalizedUrl || seen.has(normalizedUrl)) {
      return;
    }

    seen.add(normalizedUrl);
    result.push(normalizedUrl);
  });

  return result;
};

export const getSelectedWooProducts = (products = [], selectedIds = []) => {
  const selectedIdSet = new Set((selectedIds || []).map((id) => String(id)));

  return (products || []).filter((product) =>
    selectedIdSet.has(String(product.id))
  );
};

export const mergeReferenceUrls = (manualUrls = [], selectedProducts = []) => {
  const productUrls = (selectedProducts || [])
    .map((product) => product?.permalink)
    .filter(Boolean);

  return dedupeUrls([...productUrls, ...(manualUrls || [])]);
};

export const requiresWooProductSelection = (
  useWooProducts,
  selectedProductIds = []
) => {
  if (!useWooProducts) {
    return false;
  }

  return !Array.isArray(selectedProductIds) || selectedProductIds.length === 0;
};
